import {
  PHOTO_AUTHOR,
  PHOTO_AUTHOR_LINK,
  PHOTO_AUTHOR_NAME,
  PHOTO_AUTHOR_PHOTOS_NUM,
} from "../constants"

class AuthorElement {
  constructor(containerElement, linkElement, nameElement, photosNumElement) {
    this.containerElement = containerElement
    this.linkElement = linkElement
    this.nameElement = nameElement
    this.photosNumElement = photosNumElement
  }

  static fromHtmlElement(htmlElement) {
    const containerElement = htmlElement.querySelector(PHOTO_AUTHOR)
    if (!containerElement) return null

    const linkElement = containerElement.querySelector(PHOTO_AUTHOR_LINK)
    const nameElement = containerElement.querySelector(PHOTO_AUTHOR_NAME)
    const photosNumElement = containerElement.querySelector(PHOTO_AUTHOR_PHOTOS_NUM)

    return new AuthorElement(containerElement, linkElement, nameElement, photosNumElement)
  }

  apply(photo) {
    if (!this.containerElement || !photo.author) return

    if (this.nameElement) {
      this.nameElement.textContent = photo.author.name || ""
    }

    if (this.linkElement && photo.author.url) {
      this.linkElement.href = photo.author.url
    }

    if (this.photosNumElement && photo.author.photosNum !== null) {
      this.photosNumElement.textContent = photo.author.photosNum
    }
  }

  _createAndUpdateNameElement(author) {
    if (!this.nameElement !== null) {
      this.nameElement.remove()
      this.nameElement = null
    }

    this.nameElement = document.createElement("span")
    this.nameElement.appendChild(document.createTextNode(author.name))
  }

  _createAndUpdateLinkElement(author) {
    if (this.linkElement !== null) {
      this.linkElement.remove()
      this.linkElement = null
    }

    this.linkElement = document.createElement("a")
    this.linkElement.setAttribute("href", author.url)
    this.linkElement.classList.add(AUTHOR_LINK_CLASSNAME)
  }

  _createAndUpdatePhotosNumElement(author) {
    if (this.photosNumElement !== null) {
      this.photosNumElement.remove()
      this.photosNumElement = null
    }

    this.photosNumElement = document.createElement("span")
    this.photosNumElement.appendChild(document.createTextNode(` (${author.photosNum} photos)`))
  }
}

export default AuthorElement
